import { make } from 'ts-brand';

import { MaskConfig } from './types';

export const createBrandedMaskConfig = make<MaskConfig>();
